const ACCESS_LEVELS = {
    FUNCIONARIO: 1,
    RECEPCAO: 2,
    MASTER: 3
};

const ACCESS_LABELS = {
    [ACCESS_LEVELS.FUNCIONARIO]: 'Colaborador',
    [ACCESS_LEVELS.MASTER]: 'Gestor',
    [ACCESS_LEVELS.RECEPCAO]: 'Cadastro'
};

function normalizeAccessLevel(value) {
    return Number(value || 0);
}

function isFuncionario(accessLevel) {
    return normalizeAccessLevel(accessLevel) === ACCESS_LEVELS.FUNCIONARIO;
}

function isRecepcao(accessLevel) {
    return normalizeAccessLevel(accessLevel) === ACCESS_LEVELS.RECEPCAO;
}

function isMaster(accessLevel) {
    return normalizeAccessLevel(accessLevel) === ACCESS_LEVELS.MASTER;
}

function canAccessEvolutions(accessLevel) {
    return isFuncionario(accessLevel) || isMaster(accessLevel);
}

function canViewPartners(accessLevel) {
    return isFuncionario(accessLevel) || isMaster(accessLevel);
}

function canManagePartners(accessLevel) {
    return isMaster(accessLevel);
}

function canViewPatients(accessLevel) {
    return isFuncionario(accessLevel) || isMaster(accessLevel) || isRecepcao(accessLevel);
}

function canManagePatients(accessLevel) {
    return isMaster(accessLevel) || isRecepcao(accessLevel);
}

function canAccessPatients(accessLevel) {
    return canViewPatients(accessLevel);
}

function canViewSchedule(accessLevel) {
    return isFuncionario(accessLevel) || isMaster(accessLevel) || isRecepcao(accessLevel);
}

function canManageSchedule(accessLevel) {
    return isMaster(accessLevel) || isRecepcao(accessLevel);
}

function canAccessPoint(accessLevel) {
    return isFuncionario(accessLevel) || isMaster(accessLevel) || isRecepcao(accessLevel);
}

function canManagePoint(accessLevel) {
    return isMaster(accessLevel) || isRecepcao(accessLevel);
}

function canAccessReports(accessLevel) {
    return isMaster(accessLevel);
}

function getAccessLabel(accessLevel) {
    return ACCESS_LABELS[normalizeAccessLevel(accessLevel)] || 'Sem acesso';
}

export {
    ACCESS_LEVELS,
    ACCESS_LABELS,
    canAccessEvolutions,
    canAccessPatients,
    canAccessPoint,
    canAccessReports,
    canManagePartners,
    canManagePatients,
    canManagePoint,
    canManageSchedule,
    canViewPartners,
    canViewPatients,
    canViewSchedule,
    getAccessLabel,
    isFuncionario,
    isMaster,
    isRecepcao,
    normalizeAccessLevel
};
